import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@yonderland/andes-react';
import { useSelector } from 'react-redux';
import { WarrantyLabel } from '../../components/product-detail/warranty-label/WarrantyLabel';
import { makeGetProductTechnicalCategories } from '../../redux/product/selectors/ProductSelector';
import { filterProductCategoryEmptyFeatures } from '../../util/ProductUtil';
/** Feature code for the warranty feature in the ASL product service. */
const WARRANTY_FEATURE_CODE = '6. - EU GARAN Years';
/**
 * Reads the warranty feature from the product's technical categories and renders
 * a WarrantyLabel if the feature is present with a valid numeric value.
 *
 * Applies filterProductCategoryEmptyFeatures before lookup, consistent with how
 * other feature category containers consume productTechnicalCategories.
 */
export const ProductDetailWarrantyLabelContainer = ({ inPopover = false, }) => {
    const categories = useSelector(makeGetProductTechnicalCategories());
    const warrantyFeature = categories === null || categories === void 0 ? void 0 : categories.flatMap(category => filterProductCategoryEmptyFeatures(category).features).find(feature => feature.featureCode === WARRANTY_FEATURE_CODE);
    const warrantyYears = Number(warrantyFeature === null || warrantyFeature === void 0 ? void 0 : warrantyFeature.featureValue);
    if (!warrantyFeature || isNaN(warrantyYears) || warrantyYears <= 0) {
        return null;
    }
    return (_jsx(Box, { paddingBlock: "6", paddingInline: { base: inPopover ? '5' : '0', md: inPopover ? '6' : '0', xl: inPopover ? '8' : '0' }, children: _jsx(WarrantyLabel, { warrantyYears: warrantyYears }) }));
};
